import i18n from '@/i18n';
import { useCallback, useEffect, useState } from 'react';

export function useLanguage() {
    const [currentLang, setCurrentLang] = useState(i18n.resolvedLanguage ?? i18n.language ?? 'en');

    useEffect(() => {
        const handleLanguageChanged = (lang: string) => {
            setCurrentLang(lang);
        };

        i18n.on('languageChanged', handleLanguageChanged);

        return () => {
            i18n.off('languageChanged', handleLanguageChanged);
        };
    }, []);

    const handleLanguageChange = useCallback(
        (lang: string) => {
            if (!lang || lang === currentLang) return;
            i18n.changeLanguage(lang);
        },
        [currentLang],
    );

    return {
        currentLang,
        handleLanguageChange,
    };
}
